import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";

import { CommandItem } from "@/components/ui/command";
import { isLocale, localeMap, ordinaryUserLocaleValues, setLocaleServerFn } from "@/utils/locale";

import { BaseCommandGroup } from "../base";

export function LanguageCommandPage() {
  const { i18n } = useLingui();

  const handleLocaleChange = async (value: string) => {
    if (!value || !isLocale(value)) return;
    await setLocaleServerFn({ data: value });
    window.location.reload();
  };

  return (
    <BaseCommandGroup page="language" heading={<Trans>Language</Trans>}>
      {ordinaryUserLocaleValues.map((value) => (
        <CommandItem key={value} onSelect={() => handleLocaleChange(value)}>
          <span className="font-mono text-xs text-muted-foreground">{value}</span>
          {i18n.t(localeMap[value])}
        </CommandItem>
      ))}
    </BaseCommandGroup>
  );
}
